<script lang="ts" setup>
import { useAuthStore } from '@/stores/auth/auth.slice';
import { watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

watch([() => authStore?.connectStatus], ([connectStatus]) => {
  if (connectStatus == 'connected' && !route.meta.holdsWhenConnected)
    router.push('/');
});
</script>

<template>
  <RouterView />
</template>

<style lang="css"></style>
